/* Buffalo House theme JS — vanilla, no dependencies.
   Drawers, AJAX cart, variant picker, steppers, marquee, blog filter, sticky ATC. */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = (window.bhSettings && window.bhSettings.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/<[^>]+>/g, '');
  }

  /* ---------- drawers ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var focusable = d.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    var closer = e.target.closest('[data-drawer-close], .drawer__overlay');
    if (closer) { var d = closer.closest('.drawer'); if (d) closeDrawer(d); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $all('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- quantity steppers (event delegation) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var stepper = btn.closest('.qty-stepper');
    var input = stepper && stepper.querySelector('input');
    if (!input) return;
    var delta = btn.getAttribute('data-qty-change') === 'inc' ? 1 : -1;
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- AJAX cart ---------- */
  function updateCartUI(cart) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    var body = $('[data-cart-drawer-items]');
    if (body) renderDrawerItems(body, cart);
    $all('[data-cart-subtotal]').forEach(function (el) { el.textContent = formatMoney(cart.items_subtotal_price); });
    updateCaseProgress(cart);
    updateShipProgress(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  // Returns true only for genuine wine products — excludes accessories, glasses, tools, etc.
  function isWineProduct(item) {
    var pt = (item.product_type || '').toLowerCase().trim();
    if (!pt) return false;
    // Must contain "wine" somewhere in the type
    if (pt.indexOf('wine') === -1) return false;
    // Exclude anything that is clearly an accessory / tool rather than a drinkable wine
    var nonWineWords = ['accessor', 'tool', 'glass', 'opener', 'stopper', 'rack', 'fridge', 'key', 'cellar', 'decant', 'cork', 'equipment', 'supply'];
    for (var w = 0; w < nonWineWords.length; w++) {
      if (pt.indexOf(nonWineWords[w]) > -1) return false;
    }
    return true;
  }

  function updateCaseProgress(cart) {
    // Wine mix-and-match progress is now rendered inline in renderDrawerItems (wine items only).
    // Legacy standalone bar support: update only if the element still exists (cart page).
    var bar = $('[data-case-progress]');
    if (!bar) return;
    var threshold = (window.bhSettings && window.bhSettings.caseThreshold) || 12;
    var wineBottles = (cart.items || []).reduce(function (sum, i) {
      return isWineProduct(i) ? sum + i.quantity : sum;
    }, 0);
    var pct = Math.min(100, Math.round((wineBottles / threshold) * 100));
    var fill = bar.querySelector('.cart-progress__fill');
    if (fill) fill.style.width = pct + '%';
    var label = bar.querySelector('[data-case-count]');
    if (label) label.textContent = wineBottles >= threshold ? 'Case complete — discount applies at checkout!' : wineBottles + ' of ' + threshold + ' bottles';
  }

  function updateShipProgress(cart) {
    var goal = (window.bhSettings && window.bhSettings.freeDeliveryCents) || 0;
    if (!goal) return;
    $all('[data-ship-progress]').forEach(function (box) {
      var pct = Math.min(100, Math.round((cart.total_price / goal) * 100));
      var fill = box.querySelector('[data-ship-fill]');
      if (fill) fill.style.width = pct + '%';
      var label = box.querySelector('[data-ship-label]');
      if (label) {
        label.innerHTML = cart.total_price >= goal
          ? 'You\u2019ve unlocked <strong>free local delivery</strong>!'
          : 'More than <strong>' + formatMoney(goal - cart.total_price) + '</strong> to get free local delivery!';
      }
    });
  }

  // Deep links: /#cart opens the basket drawer, /#menu opens the menu drawer.
  if (location.hash === '#cart' || location.hash === '#menu') {
    var hashDrawerId = location.hash === '#cart' ? 'CartDrawer' : 'MenuDrawer';
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { openDrawer(hashDrawerId); });
    } else {
      openDrawer(hashDrawerId);
    }
  }

  function renderDrawerItems(container, cart) {
    if (!cart.items.length) {
      container.innerHTML = '<div class="cart-empty"><p class="eyebrow">My basket</p><h3>It\u2019s empty in here</h3><p>Fill it with something worth pouring.</p><a class="btn btn--primary" href="/collections/all">Shop bottles</a></div>';
      return;
    }
    var trashSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4a1.5 1.5 0 011.5-1.5h5A1.5 1.5 0 0116 4v2M19 6l-.8 13.2a2 2 0 01-2 1.8H7.8a2 2 0 01-2-1.8L5 6M10 11v6M14 11v6"/></svg>';
    var itemsHtml = cart.items.map(function (item, idx) {
      var img = item.image
        ? '<img class="cart-line__img" src="' + item.image.replace(/(\.[a-z]{3,4}\?|\.[a-z]{3,4}$)/, function (m) { return m.indexOf('?') > -1 ? '_120x' + m : '_120x' + m; }) + '" alt="" loading="lazy">'
        : '<div class="cart-line__img"></div>';
      return '<div class="cart-line" data-line="' + (idx + 1) + '">' + img +
        '<div class="cart-line__main">' +
          '<div class="cart-line__top">' +
            '<a class="cart-line__title" href="' + item.url + '">' + item.product_title + '</a>' +
            '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>' +
          '<div class="cart-line__meta">' + (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' \u00b7 ' : '') + 'Unit price: ' + formatMoney(item.final_price) + '</div>' +
          '<div class="cart-line__row">' +
            '<div class="qty-stepper">' +
              '<button type="button" data-qty-change="dec" aria-label="Decrease quantity">\u2212</button>' +
              '<input type="number" value="' + item.quantity + '" min="0" data-line-qty aria-label="Quantity">' +
              '<button type="button" data-qty-change="inc" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-line-remove aria-label="Remove item">' + trashSvg + '</button>' +
          '</div>' +
        '</div></div>';
    }).join('');

    // Wine-only mix-and-match progress (genuine wine products only, inline after items)
    var wineCount = cart.items.reduce(function (sum, item) {
      return isWineProduct(item) ? sum + item.quantity : sum;
    }, 0);
    var wineThreshold = (window.bhSettings && window.bhSettings.caseThreshold) || 12;
    if (wineCount > 0 && wineCount < wineThreshold) {
      var pct = Math.min(100, Math.round((wineCount / wineThreshold) * 100));
      itemsHtml += '<div class="wine-progress">' +
        '<div class="wine-progress__label">Mix &amp; match any <strong>' + wineThreshold + ' wines</strong> for 15% off &mdash; ' + wineCount + ' of ' + wineThreshold + ' bottles</div>' +
        '<div class="wine-progress__bar"><div class="wine-progress__fill" style="width:' + pct + '%"></div></div>' +
      '</div>';
    }
    container.innerHTML = itemsHtml;
  }

  function cartChange(line, quantity) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(updateCartUI);
  }

  document.addEventListener('change', function (e) {
    var qty = e.target.closest('[data-line-qty]');
    if (qty) {
      var line = qty.closest('[data-line]');
      if (line) cartChange(parseInt(line.getAttribute('data-line'), 10), parseInt(qty.value, 10) || 0);
    }
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (rm) {
      var line = rm.closest('[data-line]');
      if (line) cartChange(parseInt(line.getAttribute('data-line'), 10), 0);
    }
  });

  // Add-to-cart forms + quick add buttons
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var oldText;
    if (btn) { oldText = btn.textContent; btn.textContent = 'Adding…'; btn.disabled = true; }
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || 'Could not add to cart'); });
        return r.json();
      })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCartUI(cart);
        openDrawer('CartDrawer');
      })
      .catch(function (err) { alert(err.message); })
      .finally(function () { if (btn) { btn.textContent = oldText; btn.disabled = false; } });
  });

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (!quick) return;
    e.preventDefault();
    quick.classList.add('is-disabled');
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(quick.getAttribute('data-quick-add'), 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || 'Could not add to cart'); });
        return fetch('/cart.js').then(function (rr) { return rr.json(); });
      })
      .then(function (cart) { updateCartUI(cart); openDrawer('CartDrawer'); })
      .catch(function (err) { alert(err.message); })
      .finally(function () { quick.classList.remove('is-disabled'); });
  });

  /* ---------- variant picker ---------- */
  $all('[data-product-form]').forEach(function (wrap) {
    var json = $('[data-product-json]', wrap);
    if (!json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (e) { return; }
    var idInput = $('input[name="id"]', wrap);
    var priceEl = $('[data-price]', wrap);
    var compareEl = $('[data-compare-price]', wrap);
    var atcBtn = $('[data-atc-button]', wrap);
    var stockEl = $('[data-stock-note]', wrap);

    function currentOptions() {
      return $all('.variant-pill input:checked', wrap).map(function (i) { return i.value; });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    wrap.addEventListener('change', function (e) {
      if (!e.target.closest('.variant-pill input')) return;
      var variant = findVariant(currentOptions());
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.classList.add('pdp-price--sale');
        } else {
          priceEl.classList.remove('pdp-price--sale');
        }
      }
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? atcBtn.getAttribute('data-label-add') : 'Sold out';
      }
      if (stockEl) {
        stockEl.classList.toggle('stock-note--out', !variant.available);
        stockEl.querySelector('span:last-child').textContent = variant.available ? 'In stock & ready to pour' : 'Sold out';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* ---------- PDP gallery ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = $('[data-gallery-main] img', gallery);
    if (main) { main.src = thumb.getAttribute('data-src'); main.srcset = ''; }
    $all('[data-gallery-thumb]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---------- sticky ATC ---------- */
  var stickyBar = $('[data-sticky-atc]');
  var buybox = $('[data-buybox]');
  if (stickyBar && buybox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(buybox);
  }

  /* ---------- announcement marquee: duplicate track for seamless loop ---------- */
  $all('.announcement__track').forEach(function (track) {
    track.innerHTML += track.innerHTML;
  });

  /* ---------- blog client-side search filter ---------- */
  var blogSearch = $('[data-blog-search]');
  if (blogSearch) {
    blogSearch.addEventListener('input', function () {
      var q = blogSearch.value.trim().toLowerCase();
      $all('[data-blog-card]').forEach(function (card) {
        var text = (card.getAttribute('data-blog-text') || card.textContent).toLowerCase();
        card.style.display = !q || text.indexOf(q) > -1 ? '' : 'none';
      });
    });
  }

  /* ---------- ingredient checkboxes: strike-through ---------- */
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('.ingredient-row input[type="checkbox"]');
    if (!cb) return;
    var row = cb.closest('.ingredient-row');
    row.style.opacity = cb.checked ? '0.45' : '';
    row.style.textDecoration = cb.checked ? 'line-through' : '';
  });

  /* ---------- inline variant tray on product cards ---------- */
  (function () {
    function closeTray(tray) {
      tray.classList.remove('is-open');
      var card = tray.closest('.product-card');
      if (card) {
        card.classList.remove('tray-open');
        var btn = card.querySelector('[data-open-tray]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    }
    function closeAllTrays(except) {
      $all('.pc-variant-tray.is-open').forEach(function (t) { if (t !== except) closeTray(t); });
    }

    document.addEventListener('click', function (e) {
      /* open tray */
      var openBtn = e.target.closest('[data-open-tray]');
      if (openBtn) {
        e.preventDefault();
        e.stopPropagation();
        var card = openBtn.closest('.product-card');
        var tray = card && card.querySelector('.pc-variant-tray');
        if (!tray) return;
        var willOpen = !tray.classList.contains('is-open');
        closeAllTrays();
        if (willOpen) {
          tray.classList.add('is-open');
          card.classList.add('tray-open');
          openBtn.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      /* close via × */
      var closeBtn = e.target.closest('.pc-variant-tray__close');
      if (closeBtn) {
        e.stopPropagation();
        var tray = closeBtn.closest('.pc-variant-tray');
        if (tray) closeTray(tray);
        return;
      }

      /* select a variant row → add to cart */
      var row = e.target.closest('.pc-variant-tray__row:not([disabled])');
      if (row) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = parseInt(row.getAttribute('data-variant-id'), 10);
        if (!variantId) return;
        row.classList.add('is-loading');
        row.disabled = true;
        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || 'Could not add to cart'); });
            return fetch('/cart.js').then(function (rr) { return rr.json(); });
          })
          .then(function (cart) {
            updateCartUI(cart);
            openDrawer('CartDrawer');
            closeAllTrays();
          })
          .catch(function (err) { alert(err.message); })
          .finally(function () { row.classList.remove('is-loading'); row.disabled = false; });
        return;
      }

      /* click outside → close all */
      if (!e.target.closest('.pc-variant-tray') && !e.target.closest('[data-open-tray]')) {
        closeAllTrays();
      }
    });

    /* close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllTrays();
    });
  })();

  /* ---------- initial cart state ---------- */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(updateCartUI).catch(function () {});
})();

/* ---------- footer link-group accordions (mobile) ---------- */
document.addEventListener("click", function (e) {
  var t = e.target.closest("[data-footer-toggle]");
  if (!t) return;
  if (window.matchMedia("(min-width: 768px)").matches) return;
  var g = t.closest("[data-footer-group]");
  if (!g) return;
  g.classList.toggle("open");
  t.setAttribute("aria-expanded", g.classList.contains("open") ? "true" : "false");
});

/* ---------- Slide-panel mobile nav (LPB-style full-page panels) ---------- */
(function () {
  var stack = []; // panel ID history

  function openPanel(id) {
    var next = document.getElementById(id);
    if (!next) return;
    var current = document.querySelector('.mnav-panel.is-active');
    if (current) {
      current.classList.remove('is-active');
      current.classList.add('is-exiting');
    }
    next.classList.add('is-active');
    stack.push(id);
  }

  function goBack() {
    var current = document.querySelector('.mnav-panel.is-active');
    if (current) current.classList.remove('is-active');
    document.querySelectorAll('.mnav-panel.is-exiting').forEach(function (p) { p.classList.remove('is-exiting'); });
    stack.pop();
    var prevId = stack.length ? stack[stack.length - 1] : 'MnavRoot';
    var prev = document.getElementById(prevId);
    if (prev) prev.classList.add('is-active');
  }

  function resetPanels() {
    document.querySelectorAll('.mnav-panel').forEach(function (p) { p.classList.remove('is-active', 'is-exiting'); });
    var root = document.getElementById('MnavRoot');
    if (root) root.classList.add('is-active');
    stack = [];
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-mnav-open]');
    if (openBtn) { e.preventDefault(); openPanel(openBtn.getAttribute('data-mnav-open')); return; }
    var backBtn = e.target.closest('[data-mnav-back]');
    if (backBtn) { e.preventDefault(); goBack(); return; }
    // Reset when menu drawer closes
    var drawerClose = e.target.closest('[data-drawer-close]');
    if (drawerClose && drawerClose.closest('#MenuDrawer')) {
      setTimeout(resetPanels, 300);
    }
  });

  // Also reset on Escape / overlay click (handled by existing drawer code)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setTimeout(resetPanels, 300);
  });
})();

/* Product carousel arrows (featured shelves) — with boundary state for a11y */
(function () {
  function updateBtns(track) {
    var scope = track.closest('.section-pad') || document;
    var prev = scope.querySelector('[data-carousel-prev]');
    var next = scope.querySelector('[data-carousel-next]');
    if (!prev || !next) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    if (track.scrollLeft <= 2) prev.setAttribute('disabled', ''); else prev.removeAttribute('disabled');
    if (track.scrollLeft >= max) next.setAttribute('disabled', ''); else next.removeAttribute('disabled');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    var scope = btn.closest('.section-pad') || document;
    var track = scope.querySelector('[data-carousel-track]');
    if (!track) return;
    var dir = btn.hasAttribute('data-carousel-prev') ? -1 : 1;
    track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
  });

  function initTracks() {
    document.querySelectorAll('[data-carousel-track]').forEach(function (track) {
      updateBtns(track);
      var pending = false;
      track.addEventListener('scroll', function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; updateBtns(track); });
      }, { passive: true });
    });
    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-carousel-track]').forEach(updateBtns);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTracks);
  else initTracks();
})();
